// extracted by mini-css-extract-plugin
export default {"SettingsContentHeader":"SettingsContentHeader_SettingsContentHeader__y9VU3","SettingsContentHeaderWithGutter":"SettingsContentHeader_SettingsContentHeaderWithGutter__sgjcr"};